import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import { Alert, Badge, Container, Image, Table } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";

const RewardsHistory = () => {
	async function getRewardsHistory(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/rewards/history").then((r)=>r.json().then((json)=>{
            return json
        }))
    }

    const location = useLocation()
	const [rewardsHistory,setRewardsHistory] = useState([])

	useEffect(() => {
		document.querySelector("title").textContent = "特典応募履歴 - アワートAI"
		getRewardsHistory().then(r=>{
			if(r.result){
				setRewardsHistory(r.data)
			}
		})
	},[location.pathname])
    function getLabel(status){
        if(status == null || status == "") return "応募する"
        if(status == "PENDING") return "応募済"
        if(status == "WON") return "当選"
        if(status == "LOST") return "落選"
        return ""
    }
    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Header />
        <Category />
        <Container>
            <h3 style={{color:"#444444"}}><Icon.Gift /> 特典応募履歴</h3>
            <Table striped bordered hover>
                <thead>
                    <tr><th>応募日</th><th>商品名</th><th>状況</th></tr>
                </thead>
                <tbody>
                {rewardsHistory && rewardsHistory.map((d,i) => {
                    let text = ""
                    let eventId = ""
                    return <tr key={i}><td>{d.ymd}</td><td>{d.item_name}</td><td>{getLabel(d.status)}{d.status === "WON" ? <><br /><span style={{color:"#555555"}}> 配送業者：{d.delivery_company} 追跡番号：{d.tracking_number}</span></> : ""}</td></tr>
                })}
                </tbody>
            </Table>
        </Container>
        <Footer />
    </div>
    )
}

export default RewardsHistory;
